import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { BrowserRouter as Router, Outlet, Route, Routes } from 'react-router';
import { registerLocale } from 'react-datepicker';
import { fi } from 'date-fns/locale/fi';
import { sv } from 'date-fns/locale/sv';
// import global styles first
import 'react-datepicker/dist/react-datepicker.css';
import './styles.css';
import { defaultLokalisointi, I18nImpl, LanguageContext } from './LanguageContext';
import { JotpaRekisterointi } from './jotpa/JotpaRekisterointi';
import { JotpaLanding } from './jotpa/JotpaLanding';
import { JotpaValmis } from './jotpa/JotpaValmis';
import { Footer } from './Footer';
import { useGetLanguageQuery, useGetLocalizationQuery } from './rekisterointiApi';
registerLocale('fi', fi);
registerLocale('sv', sv);
function App() {
    const { data: language } = useGetLanguageQuery();
    const { data: localization } = useGetLocalizationQuery();
    const i18n = useMemo(() => new I18nImpl(localization ?? defaultLokalisointi, language ?? 'fi'), [language, localization]);
    if (!language || !localization) {
        return _jsx("div", {});
    }
    return (_jsxs(LanguageContext.Provider, { value: { language, i18n }, children: [_jsx("a", { className: "skip-to-content", href: "#main", children: i18n.translate('hyppaa_sisaltoon') }), _jsxs(Router, { children: [_jsxs(Routes, { children: [_jsx(Route, { path: "/jotpa", element: _jsx(JotpaLanding, {}) }), _jsx(Route, { path: "/jotpa/valmis", element: _jsx(JotpaValmis, {}) }), _jsx(Route, { path: "/hakija", children: _jsx(Route, { path: "jotpa/*", element: _jsx(JotpaRekisterointi, {}) }) })] }), _jsx(Outlet, {})] }), _jsx(Footer, {})] }));
}
export default App;
